import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Linkedin, Copy, Check, ChevronDown, ChevronUp } from "lucide-react";

export const OutreachLinkedin = ({ message, linkedinUrl, copied, onCopy }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="space-y-2">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between text-sm font-medium text-gray-300 uppercase tracking-wider hover:text-white transition-colors" data-testid="toggle-linkedin-section">
        <span className="flex items-center gap-2"><Linkedin className="h-4 w-4 text-blue-400" /> LinkedIn Message</span>
        {open ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
      </button>
      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} exit={{ opacity: 0, height: 0 }} className="space-y-2 overflow-hidden">
            <div className="p-3 rounded-lg bg-white/5 border border-white/10 text-sm text-gray-300 whitespace-pre-wrap" data-testid="linkedin-message">{message || "No LinkedIn message generated."}</div>
            <div className="flex gap-2">
              <Button onClick={onCopy} size="sm" variant="outline" className="text-xs border-white/20 text-gray-400 hover:text-white" data-testid="copy-linkedin-btn">
                {copied ? <Check className="h-3 w-3 mr-1" /> : <Copy className="h-3 w-3 mr-1" />}{copied ? "Copied" : "Copy Message"}
              </Button>
              {linkedinUrl && (
                <a href={linkedinUrl} target="_blank" rel="noopener noreferrer">
                  <Button size="sm" variant="outline" className="text-xs border-blue-500/30 text-blue-400 hover:text-blue-300" data-testid="open-linkedin-btn"><Linkedin className="h-3 w-3 mr-1" /> Open Profile</Button>
                </a>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
